import type { MultilingualConfigValue, MultilingualNodeConfig, MultilingualProperties } from "../../schemas/index.ts";

export const isNotVariablesProperty = <T extends MultilingualNodeConfig, P extends keyof T>(
  _config: T,
  property: P,
): property is Exclude<P, "variables"> => property !== "variables";

export const isMultilingualProperty = (value: unknown): value is MultilingualProperties =>
  value !== null && typeof value === "object" && "__ml" in value && typeof value.__ml === "object";

export const isNestingProperty = (value: unknown): value is Record<string, MultilingualConfigValue> =>
  value !== null && typeof value === "object" && !Array.isArray(value) && !isMultilingualProperty(value);
